import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_ALL_BID_AUCTIONS,
  GET_ALL_CATEGORIES,
  GET_ALL_PAST_AUCTIONS,
  GET_ALL_RUNNING_AUCTIONS,
  GET_ALL_USERS,
  GET_ANALYTICS_DATA,
  GET_BADGE_LISTS,
  GET_BID_TOTAL,
  GET_CONTACT_LISTS,
  GET_ITEM_LISTING,
  GET_ITEM_TOTAL,
  GET_LOGS_DATA,
  GET_NEWSLETTER_LISTS,
  GET_ORDER_LISTS,
  GET_PAST_TOTAL,
  GET_PAYMENT_LISTS,
  GET_PRODUCT_DETAIL,
  GET_RUNNING_TOTAL,
  GET_SINGLE_STAFF,
  GET_STAFF_LISTING,
  GET_TOTAL_CATEGORIES,
  GET_TOTAL_USERS,
  USER_DISPUTES,
  USER_FLAG_COMMENTS,
} from "./userTypes";
import { start_loading, stop_loading } from "../loader/loaderAction";
import moment from "moment";
import { RESET_TOKEN } from "../auth/authTypes";
import apiClient from "../../api/apiClient";
import { Category, QrCodeScannerOutlined, Search } from "@mui/icons-material";
import { ArrowSquareDown } from "@phosphor-icons/react";
// import { Category } from "@mui/icons-material";

const { REACT_APP_BASE_URL } = process.env;
const get_token = () => {
  let token = localStorage.getItem("token");
  return token;
};
// const token = get_token()
export const DESIGNATION = [
  {
    label: "Reviewer",
    value: "reviewers",
  },
  {
    label: "Manager",
    value: "managers",
  },
  {
    label: "Owner",
    value: "owners",
  },
];

export const show_success = (message) => {
  toast(message, { autoClose: 2000 });
};

const headers = {
  "Content-Type": "application/json",
  "x-access-token": get_token(),
};

export const check_token_expired_logout = (data, dispatch) => {
  if (data?.request?.status === 401) {
    toast.error(data.response.data.error, {
      toastId: "sessionexpired",
      autoClose: 2000,
    });
    dispatch({ type: RESET_TOKEN, payload: true });
    setTimeout(() => {
      localStorage.clear();
      window.location.reload();
    }, 2000);
  }
};

export const gotToExport = (data, label) => {
  const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `${label}(${moment()?.format("MMM DD, YYYY")?.replace(/,/g, "")}).csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const upload_image = async (photo, token, dispatch) => {
  const formData = new FormData();
  // photo.forEach((v) => {
  //   formData.append(`images`, v);
  // });
  formData.append("image", photo);

  const HEADERS = {
    headers: {
      "x-access-token": token,
    },
  };

  try {
    const urlPath = `${REACT_APP_BASE_URL}auth/upload-image`;
    const res = await axios.post(urlPath, formData, HEADERS);

    if (res.data && res.data.status) {
      // toast.success(res.data.message, { toastId: "uploadphto", autoClose: 2000, });
      return res;
    } else {
      toast.error(res.data.message, { toastId: "photoerr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    // check_token_expired_logout(error, dispatch);
  }
};

export const upload_multiple_image = async (formData, token) => {
  const HEADERS = {
    headers: {
      "x-access-token": token,
      "Content-Type": "multipart/form-data",
    },
  };
  try {
    const urlPath = `${REACT_APP_BASE_URL}item/upload-item-image`;
    const res = await axios.post(urlPath, formData, HEADERS);
    return res;
  } catch (error) {
    toast.error(error.response?.data?.message || "Invalid Extension");
    return false;
  }
};

export const get_export_users = async (dispatch, token, userId) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/export-user`;

    const res = await apiClient.post(urlPath, {
      userIds: userId ? [userId] : [],
    });

    if (res?.data) {
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
    console.error("Error:", error);
  } finally {
    dispatch(stop_loading());
  }
};

export const update_password = async (userdata, token, dispatch) => {
  try {
    const urlPath = `profile/change-password`;

    const res = await apiClient.put(urlPath, userdata);

    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "updatpwd", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, {
        toastId: "updatedpwderr",
        autoClose: 1000,
      });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.error, {
      toastId: "updatedwwwww",
      autoClose: 1000,
    });
    // catch_errors_handle(error);
    check_token_expired_logout(error, dispatch);
  }
};

export const get_export_sales = async (dispatch, token, userId, year) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/export-sales-report`;

    const res = await apiClient.post(urlPath, {
      user_id: userId === "ALL" ? null : userId,
      start_date: moment().year(year).startOf("year"),
      end_date: moment().year(year).endOf("year"),
    });

    if (res?.data) {
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
    console.error("Error:", error);
  } finally {
    dispatch(stop_loading());
  }
};

export const withdraw_auction = async (dispatch, token, itemId) => {
  dispatch(start_loading());
  try {
    const urlPath = `admin/auction-withdrawn`;

    const res = await apiClient.put(urlPath, { itemId: itemId });

    if (res?.data) {
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  } finally {
    dispatch(stop_loading());
  }
};

// export const get_users = async (
//   dispatch,
//   token,
//   currentPage,
//   perPage,
//   search,
// ) => {
//   try {
//     const HEADERS = {
//       headers: {
//         "x-access-token": token
//       }
//     };
//     const urlPath = `${REACT_APP_BASE_URL}admin/user-list?page=${currentPage}&limit=${perPage}${search ? `&search=${search}` : ""}`;

//     const res = await axios.get(urlPath, HEADERS);

//     if (res?.data?.data) {
//       dispatch({ type: GET_ALL_USERS, payload: res?.data?.data });
//       dispatch({ type: GET_TOTAL_USERS, payload: Number(res.data.length) });
//       return res?.data;
//     } else {
//       console.log("You have an error");
//     }
//   } catch (error) {
//     check_token_expired_logout(error, dispatch);
//     console.error("Error:", error);
//   }
// };

export const get_users = async (
  dispatch,
  token,
  currentPage,
  perPage,
  search,
  status,
  role
) => {
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };

    let urlPath = `${REACT_APP_BASE_URL}admin/user-list?page=${currentPage}&limit=${perPage}&role=${role}`;
    if (search) urlPath += `&search=${search}`;
    if (status && status !== "All") urlPath += `&status=${status}`;
    // if (role) urlPath += `&role=${role}`; // 👈 append filter

    const res = await axios.get(urlPath, HEADERS);
    if (res?.data?.data) {
      dispatch({ type: GET_ALL_USERS, payload: res?.data?.data });
      dispatch({ type: GET_TOTAL_USERS, payload: Number(res.data.length) });
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
    console.error("Error:", error);
  }
};

///admin/wallet-transactions

// wallet apis start
export const get_wallet_users = async (filter) => {
  try {
    // let urlPath = `${REACT_APP_BASE_URL}admin/user-list?page=${currentPage}&limit=${perPage}&role=${role}`;
    let urlPath = `admin/wallet-transactions-pending-list?transaction_status=${filter}`;
    // if (search) urlPath += `&search=${search}`;
    // if (status && status !== "All") urlPath += `&status=${status}`;
    // if (role) urlPath += `&role=${role}`; // 👈 append filter

    const res = await apiClient.get(urlPath);
    if (res?.data?.data) {
      // dispatch({ type: GET_ALL_USERS, payload: res?.data?.data });
      // dispatch({ type: GET_TOTAL_USERS, payload: Number(res.data.length) });
      return res?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
    console.error("Error:", error);
  }
};

export const post_wallet_verification = async (data, id) => {
  try {
    const urlPath = `admin/update-order-verification/${id}`;
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Wallet updated successfully");
    return true;
  } catch (error) {}
};

export const post_order_verification = async (data) => {
  try {
    const urlPath = `admin/update-order-details`;
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Wallet updated successfully");
  } catch (error) {}
};

//  wallet apis end

export const get_particular_user = async (id, token, dispatch) => {
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/user-details/${id}`;

    const res = await axios.get(urlPath, HEADERS);

    if (res?.data?.data) {
      return res?.data?.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const get_newsletter_lists = async (
  token,
  dispatch,
  page,
  limit,
  search
) => {
  try {
    const HEADERS = {
      headers: { "x-access-token": token },
    };
    let urlPath = `${REACT_APP_BASE_URL}admin/get-newsletter?page=${page}&limit=${limit}`;
    if (search) urlPath += `&search=${search}`;
    const res = await axios.get(urlPath, HEADERS);
    if (res?.data && res?.data?.status) {
      dispatch({ type: GET_NEWSLETTER_LISTS, payload: res?.data });
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const delete_newsletter_email = async (dispatch, token, id) => {
  try {
    const HEADERS = {
      headers: { "x-access-token": token },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/delete-newsletter/${id}`;
    const res = await axios.delete(urlPath, HEADERS);
    if (res?.data && res?.data?.status) {
      show_success("Email Deleted Successfully");
      return true;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const get_contact_lists = async (
  token,
  dispatch,
  page,
  limit,
  search
) => {
  try {
    const HEADERS = {
      headers: { "x-access-token": token },
    };
    let urlPath = `${REACT_APP_BASE_URL}admin/get-query-form?page=${page}&limit=${limit}`;
    if (search) urlPath += `&search=${search}`;

    const res = await axios.get(urlPath, HEADERS);
    if (res?.data && res?.data?.status) {
      dispatch({ type: GET_CONTACT_LISTS, payload: res?.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const searchUsersAPI = async (searchTerm) => {
  try {
    const res = await apiClient.get(
      `admin/search-users?searchTerm=${searchTerm}`
    );
    if (res.data && res.data.status) {
      return res.data.users;
    }
    return [];
  } catch (error) {
    console.error("API Error searching users:", error);
    toast.error("Could not fetch users.");
    return [];
  }
};

export const sendNotificationAPI = async (payload) => {
  try {
    const res = await apiClient.post("admin/notify", payload);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
    toast.error(res.data.message || "An error occurred.");
    return false;
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to send notification."
    );
    return false;
  }
};

export const update_user = async (
  id,
  data,
  navigate,
  token,
  dispatch,
  isActive,
  message
) => {
  // if (data?.isDeactive === "Deactivate") {
  //   data.isDeactive = true;
  // } else {
  //   data.isDeactive = false;
  // }

  try {
    const urlPath = `${REACT_APP_BASE_URL}admin/user-edit/${id}`;

    const res = await axios.post(urlPath, JSON.stringify(data), {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });

    if (res?.data?.data) {
      // if (!isActive) {
      show_success(isActive ? message : res?.data?.message);

      // }
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const delete_user = async (dispatch, token, userId) => {
  // dispatch(start_loading());
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/delete-user/${userId}`;
    const res = await axios.delete(urlPath, HEADERS);

    if (res?.data) {
      show_success(res?.data?.message);
      return true;
    }
  } catch (error) {
    //check_token_expired_logout(error, dispatch);
  } finally {
    // dispatch(stop_loading());
  }
};

export const delete_product = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const url = `${REACT_APP_BASE_URL}admin/delete-master-products/${id}`;
    const res = await axios.delete(url, headers);
    if (res?.data) {
      show_success(res?.data?.message);
      return true;
    }
  } catch (error) {}
};

export const update_admin = async (data, navigate, token, dispatch) => {
  try {
    const urlPath = `${REACT_APP_BASE_URL}admin/edit-admin`;
    const HEADERS = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(urlPath, JSON.stringify(data), HEADERS);
    if (res.status && res?.data?.data) {
      localStorage.setItem("profile", JSON.stringify(res?.data?.data));
      show_success("Profile Updated Successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2700);
      return true;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error(
      error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Error"
    );
    //check_token_expired_logout(error, dispatch);
  }
};

export const get_all_sell_Item = async (page, status) => {
  try {
    const urlPath = `admin/get-auction-admin?limit=10&page=${page}&status=${status}`;
    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      return res?.data?.data;
    }
  } catch (error) {
    console.error("Error:", error);
    // check_token_expired_logout(error, dispatch);
  }
};

export const get_admin_live_bids = async (page, status) => {
  try {
    const urlPath = `/admin/get-bids-admin`;
    const res = await apiClient.get(urlPath);
    if (res.data && res.data.status) {
      return res?.data?.data;
    }
  } catch (error) {
    console.error("Error:", error);
    // check_token_expired_logout(error, dispatch);
  }
};

export const get_single_sell_Item = async (id, dispatch) => {
  try {
    const urlPath = `item/detail?slug=${id}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      return res.data.data;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const get_product_Detail = async (token, id, dispatch) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/master-products-detail/${id}`;
    const res = await axios.get(urlPath, headers);
    if (res?.data) {
      dispatch({ type: GET_PRODUCT_DETAIL, payload: res.data.data });
      return res?.data?.data;
    }
  } catch (error) {
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Failed"
    );
  }
};

export const edit_item_list = async (user, navigate, token) => {
  try {
    const urlPath = `item/add`;

    const res = await axios.post(urlPath, user);

    if (res?.data?.status) {
      navigate("/item-listing");
      show_success(res?.data?.message);
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);

    check_token_expired_logout(error);
    // Handle error here
  } finally {
  }
};

export const auction_details = async (slug, token, dispatch) => {
  try {
    const url = `${REACT_APP_BASE_URL}admin/item-details/${slug}`;
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };
    const res = await axios.get(url, HEADERS);

    if (res?.data && res?.data?.status) {
      return res.data.data;
    }
  } catch (error) {
    // console.error("Error:", error);
    //check_token_expired_logout(error, dispatch);
  }
};

export const approve_auction = async (
  itemdata,
  navigate,
  token,
  dispatch,
  status
) => {
  try {
    const url = `${REACT_APP_BASE_URL}admin/approve-item`;
    const HEADERS = {
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    };
    const res = await axios.post(url, itemdata, HEADERS);

    if (res?.data && res?.data?.status) {
      show_success(
        status === "approved"
          ? "Approved Successfully"
          : "Rejected Successfully"
      );
      // navigate("/item-listing");
      return res.data;
    }
  } catch (error) {
    console.error("Error:", error);
    //check_token_expired_logout(error, dispatch);
  } finally {
  }
};

export const unapprove_auction = async (
  itemdata,
  navigate,
  token,
  dispatch
) => {
  try {
    const urlPath = `admin/approve_auction`;

    const res = await apiClient.put(urlPath, itemdata);

    if (res?.data && res?.data?.status) {
      navigate("/item-listing");
      show_success(res?.data?.message);
      return res;
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  } finally {
  }
};

export const get_past_auctions = async (
  dispatch,
  token,
  page,
  limit,
  categories
) => {
  try {
    const urlPath = `admin/past_auction?page=${page}&limit=${limit}${
      categories ? `&${categories}` : ""
    }`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_PAST_AUCTIONS, payload: res?.data?.data });
      dispatch({ type: GET_PAST_TOTAL, payload: res.data.total });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const manage_sub_category = async (data, token, dispatch, id) => {
  try {
    const urlPath = id
      ? `/admin/sub_edit_category/${id}`
      : `/admin/sub_category`;

    const response = await apiClient.post(urlPath, data);

    if (response?.status >= 200 && response?.status < 300) {
      show_success(response?.data?.message);
    } else {
      throw new Error("Network response was not ok");
    }
    return response;
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// export const add_category = async (data, token, dispatch) => {
//   try {
//     const HEADERS = {
//       headers: {
//         "x-access-token": token,
//         "Content-Type": 'application/json'
//       }
//     };
//     const urlPath = `${REACT_APP_BASE_URL}admin/create-category`;
//     const response = await axios.post(urlPath, JSON.stringify(data), HEADERS);

//     // Check if the response is successful (status code 2xx)
//     if (response?.status >= 200 && response?.status < 300) {
//       show_success(response?.data?.message);
//     } else {
//       throw new Error("Network response was not ok");
//     }

//     return response;
//   } catch (error) {
//     console.error("Error:", error);
//     check_token_expired_logout(error, dispatch);
//     throw error; // Rethrow the error to handle it in the calling code if needed
//   }
// };

export const add_category = async (data, token, dispatch) => {
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}admin/create-category`;
    const response = await axios.post(urlPath, data, HEADERS);

    // If backend created successfully
    if (response?.status >= 200 && response?.status < 300) {
      show_success(response?.data?.message || "Category created successfully!");
    }
    return response;
  } catch (error) {
    console.error("Error:", error);

    if (error?.response?.status === 422) {
      toast.error(error?.response?.data?.message || "Category already exists!");
      return error.response; // return so caller knows it failed
    }

    if (error?.response?.data?.message) {
      console.log(error.response.data.message);
    } else {
      console.log("Something went wrong. Please try again.");
    }

    check_token_expired_logout(error, dispatch);
    throw error;
  }
};

export const edit_category = async (data, token, id, dispatch) => {
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/edit-category/${id}`;
    const response = await axios.put(urlPath, JSON.stringify(data), HEADERS);

    if (!response?.data?.status) {
      throw new Error("Network response was not ok");
    } else {
      show_success(response?.data?.message);
    }

    return response;
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const edit_product = async (token, values, id, navigate) => {
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `admin/edit-master-products/${id}`;

    const res = await apiClient.put(urlPath, values);
    if (res.data) {
      show_success(res?.data?.message);
      navigate("/products");
      return true;
    }
  } catch (error) {}
};

export const apply_feature_category = async (data, token, id, dispatch) => {
  try {
    const urlPath = `admin/edit_category/${id}`;

    const response = await apiClient.put(urlPath, data);

    if (response.data && response?.data?.status) {
      toast.success(response.data.message, { toastId: "succesone" });
    }
  } catch (error) {
    toast.error(error.response.data.message, { toastId: "suceestwo" });
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

// export const get_category = async (dispatch, token, page, limit, search) => {
//   try {
//     const HEADERS = {
//       headers: {
//         "x-access-token": token,
//       }
//     };
//     const urlPath = `${REACT_APP_BASE_URL}admin/list-category?page=${page}&limit=${limit}${search ? `&search=${search}` : ''}`;

//     const res = await axios.get(urlPath, HEADERS);

//     if (res.data && res.data.status) {
//       dispatch({ type: GET_ALL_CATEGORIES, payload: res.data.data });
//       dispatch({ type: GET_TOTAL_CATEGORIES, payload: Number(res.data.length) });
//       return res;
//     } else {
//       console.log("You have an error");
//     }
//   } catch (error) {
//     console.error("Error:", error);
//     check_token_expired_logout(error, dispatch);
//   }
// };

export const get_category = async (
  dispatch,
  token,
  page,
  limit,
  search,
  status
) => {
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };

    // Build query params dynamically
    let urlPath = `${REACT_APP_BASE_URL}admin/list-category`;
    if (page || limit) urlPath += `?page=${page}&limit=${limit}`;
    if (search) urlPath += `&search=${search}`;
    if (status && status !== "All") urlPath += `&status=${status}`;

    const res = await axios.get(urlPath, HEADERS);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_CATEGORIES, payload: res?.data?.data });
      // localStorage.setItem("categories", JSON.stringify(res?.data?.data));
      dispatch({
        type: GET_TOTAL_CATEGORIES,
        payload: Number(res.data.length),
      });

      return res.data;
    } else {
      console.log("Error: Invalid response format");
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const search_products = async (token, s, status, page, limit) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    let urlPath = `${REACT_APP_BASE_URL}item/get-master-product?search=${s}&page=${page}&limit=${limit}`;
    if (status) {
      urlPath += `&status=${status}`;
    }
    const res = await axios.get(urlPath, headers);
    if (res?.data) {
      return res?.data;
    }
  } catch {}
};

export const delete_category = async (id, token, dispatch, message) => {
  try {
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/delete-category/${id}`;
    const res = await axios.delete(urlPath, HEADERS);

    if (res.data && res.data.status) {
      show_success(message);
      // show_success(res?.data?.message);
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const get_running_auctions = async (
  dispatch,
  token,
  page,
  limit,
  categories
) => {
  try {
    const urlPath = `admin/running_auction?page=${page}&limit=${limit}${
      categories ? `&${categories}` : ""
    }`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_RUNNING_AUCTIONS, payload: res?.data?.data });
      dispatch({ type: GET_RUNNING_TOTAL, payload: res?.data?.total });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const get_all_auction_category = async () => {
  try {
    const urlPath = `admin/list_category`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      return res.data.data;
    } else {
    }
  } catch (error) {
    check_token_expired_logout(error);
  }
};

export const sell_video_game = async (userdata, dispatch) => {
  try {
    const urlPath = `item/add`;

    const res = await apiClient.post(urlPath, userdata);

    if (res.data && res.data.status) {
      toast.success(res.data.message, {
        toastId: "itemupdetsws",
        autoClose: 2000,
      });
      return true;
    } else {
      toast.error(res.data.message);
      return false;
    }
  } catch (error) {
    // console.log("//////////////", error)
    check_token_expired_logout(error, dispatch);
  }
};

export const upload_sell_item_photo = async (photo, token, dispatch) => {
  const formData = new FormData();

  photo.forEach((v) => {
    formData.append(`photos`, v);
  });
  formData.append("type", "item/image");

  try {
    const urlPath = `add-item/mediaImage`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.error, { toastId: "editphotoerrr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    // catch_errors_handle(error);
    check_token_expired_logout(error, dispatch);
  }
};

export const upload_public_doc = async (photo, token, dispatch) => {
  const formData = new FormData();

  photo.forEach((v) => {
    formData.append(`public_file`, v);
  });

  try {
    const urlPath = `upload-public-doc`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.data.error, {
        toastId: "editphotoerrr",
        autoClose: 2000,
      });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    check_token_expired_logout(error, dispatch);
  }
};

export const upload_edit_item_video = async (video, token, dispatch) => {
  // dispatch(start_loading());
  try {
    const formData = new FormData();
    video.forEach((v) => {
      formData.append(`video`, v);
    });
    formData.append("type", "item/video");

    const urlPath = `add-item/videoupload`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.error, { toastId: "editvideoerrr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    check_token_expired_logout(error, dispatch);
  } finally {
    // dispatch(stop_loading());
  }
};
export const add_item = async (token, values) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/add-master-product`;
    const res = await axios.post(urlPath, values, headers);
    if (res.data && res.data.status) {
      show_success(res.data.message);
      return res;
    }
  } catch (error) {
    toast.error(
      error?.response?.message ||
        error?.response?.data?.error ||
        "Error adding item"
    );
  }
};

export const get_master_products = async (
  search,
  token,
  filter,
  page = 1,
  limit = 10
) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `item/get-master-products?search=${search}&status=${filter}&page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath, headers);
    if (res.data) {
      return res;
    }
  } catch (error) {
    toast.error(res?.response?.data);
  }
};

export const upload_sell_item_logal_docs = async (
  legal_doc,
  token,
  dispatch
) => {
  try {
    const formData = new FormData();
    legal_doc.forEach((doc) => {
      formData.append("legal_doc", doc);
    });
    formData.append("type", "item/legalDocs");

    // formData.append('legal_doc', legal_doc);
    const urlPath = `add-item/legaldocs`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.data.message);
      return false;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const get_all_bid_items = async (
  dispatch,
  token,
  search,
  page,
  limit
) => {
  try {
    const urlPath = `item/all_items?search=${
      search ? search : ""
    }&page=${page}&limit=${limit}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_ALL_BID_AUCTIONS, payload: res.data.data });
      dispatch({ type: GET_BID_TOTAL, payload: res.data.total });
      return res;
    }
  } catch (error) {
    console.log("bid management", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const get_item_bid_detail = async (itemId, token, dispatch) => {
  try {
    const urlPath = `item/all_bids?itemId=${itemId}`;

    const res = await apiClient.get(urlPath);

    return res;
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

//badge apis

export const get_badge_lists = async (token, dispatch) => {
  try {
    const urlPath = `admin/list-badge`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_BADGE_LISTS, payload: res.data.data });
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const add_badge = async (token, badge_data, badgeId, dispatch) => {
  try {
    const urlPath = badgeId
      ? `admin/update-badge/${badgeId}`
      : `admin/add-badge`;

    const res = await (badgeId
      ? apiClient.put(urlPath, badge_data)
      : apiClient.post(urlPath, badge_data));

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const delete_badge = async (token, badgeId, dispatch) => {
  try {
    const urlPath = `admin/delete-badge/${badgeId}`;

    const res = await apiClient.delete(urlPath);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const delete_faq_question = async (token, faqId, dispatch) => {
  try {
    const url = `${REACT_APP_BASE_URL}admin/delete-content/seller`;
    const HEADERS = {
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      data: { id: faqId },
    };

    const res = await axios.delete(url, HEADERS);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      toastId: "deltefaw",
      autoClose: 2000,
    });
    check_token_expired_logout(error, dispatch);
  }
};

export const get_user_sales_history = async (token, data, dispatch) => {
  try {
    const urlPath = `user/sales-report`;

    const res = await apiClient.post(urlPath, data);

    if (res.data && res.data.status) {
      // console.log(res.data);
      return res.data.data;
    } else {
    }
  } catch (error) {
    toast.error(error.response.data.error, {
      toastId: "saleshistiewr",
      autoClose: 2000,
    });
    check_token_expired_logout(error, dispatch);
  }
};

export const get_all_staff = async (
  token,
  dispatch,
  page,
  limit,
  search,
  uid
) => {
  try {
    const urlPath = `admin/staff-list?page=${page}&limit=${limit}${
      search ? `&search=${search}` : ""
    }`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_STAFF_LISTING, payload: { ...res.data, uid: uid } });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const get_staff = async (token, dispatch, id) => {
  try {
    const urlPath = `admin/get-staff/${id}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_SINGLE_STAFF, payload: res.data.data });
      return res;
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    console.error("Error:", error);
    check_token_expired_logout(error, dispatch);
  }
};

export const manage_staff = async (token, data, id, dispatch) => {
  try {
    const urlPath = id ? `admin/editUser?userId=${id}` : `admin/create-staff`;

    const res = await (id
      ? apiClient.put(urlPath, data)
      : apiClient.post(urlPath, data));

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      get_all_staff(token, dispatch, 1, 10, null);
      return true;
    } else {
      toast.error(res.data.error, {
        toastId: "errorsearchsaved",
        autoClose: 1000,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);
    //toast.error(error.response.data.error || error.response.data.message, { toastId: "errorsearchsaved", autoClose: 1000 });
    check_token_expired_logout(error, dispatch);
  }
};

export const user_dispute = async (
  dispatch,
  token,
  page,
  limit,
  search,
  method,
  data
) => {
  try {
    const urlPath =
      method === "get"
        ? `admin/dispute-list?page=${page}&limit=${limit}${
            search ? `&search=${search}` : ""
          }`
        : `admin/change-status`;

    const res = await (method === "get"
      ? apiClient.get(urlPath)
      : apiClient.put(urlPath, data));

    if (res.data && res.data.status) {
      if (method == "get") {
        dispatch({ type: USER_DISPUTES, payload: res.data });
      } else {
        toast.success(res.data.message, {
          toastId: "savedsearchshs",
          autoClose: 1000,
        });
        return true;
      }
    }
  } catch (error) {
    toast.error(error.response.data.error, {
      toastId: "errorsearchsaved",
      autoClose: 1000,
    });
    check_token_expired_logout(error, dispatch);
  }
};

export const user_flag_comments = async (
  dispatch,
  token,
  page,
  limit,
  search,
  method,
  data
) => {
  try {
    const urlPath =
      method === "get"
        ? `item/flag-Comments?page=${page}&limit=${limit}${
            search ? `&search=${search}` : ""
          }`
        : `item/flag-Comments-status`;

    const res = await (method === "get"
      ? apiClient.get(urlPath)
      : apiClient.post(urlPath, data));

    if (res.data && res.data.status) {
      if (method == "get") {
        dispatch({ type: USER_FLAG_COMMENTS, payload: res.data });
      } else {
        toast.success("Succussfully updated flag comment status!", {
          toastId: "savedsearchshs",
          autoClose: 1000,
        });
        return true;
      }
    }
  } catch (error) {
    toast.error(error.response.data.error, {
      toastId: "errorsearchsaved",
      autoClose: 1000,
    });
    check_token_expired_logout(error, dispatch);
    return false;
  }
};

export const getPendingFlagsAPI = async (page = 1, limit = 10) => {
  try {
    const res = await apiClient.get(
      `admin/flags/pending?page=${page}&limit=${limit}`
    );

    if (res.data && res.data.status) {
      return res.data;
    } else {
      toast.error(res.data.message || "Could not fetch reports.");
      return { data: [], total: 0 };
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to load reports.");
    console.error("API Error fetching pending flags:", error);
    return null;
  }
};

export const reviewFlagAPI = async (payload) => {
  try {
    const res = await apiClient.post("admin/flags/review", payload);

    if (res.data && res.data.status) {
      return true;
    } else {
      toast.error(
        res.data.message || "An error occurred while reviewing the report."
      );
      return false;
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message || "Failed to review the report."
    );
    console.error("API Error reviewing flag:", error);
    return false;
  }
};

export const getAwardsAPI = async () => {
  try {
    const res = await apiClient.get("admin/list-award");

    if (res.data && res.data.status) {
      return res.data.data;
    } else {
      toast.error(res.data.message || "Could not fetch awards.");
      return [];
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to load awards.");
    console.error("API Error fetching awards:", error);
    return null;
  }
};

export const createAwardAPI = async (awardData) => {
  try {
    const res = await apiClient.post("admin/add-award", awardData);

    if (res.data && res.data.status) {
      toast.success("Award created successfully!");
      return res.data.data;
    } else {
      toast.error(res.data.message || "Could not create award.");
      return null;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to create award.");
    console.error("API Error creating award:", error);
    return null;
  }
};

export const grantAwardAPI = async (userId, awardId) => {
  try {
    const res = await apiClient.post("admin/grant-award", { userId, awardId });

    if (res.data && res.data.status) {
      toast.success(res.data.message || "Award granted successfully!");
      return true;
    } else {
      toast.error(res.data.message || "Could not grant award.");
      return false;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to grant award.");
    console.error("API Error granting award:", error);
    return false;
  }
};

export const updateAwardAPI = async (awardId, awardData) => {
  try {
    const res = await apiClient.put(`admin/update-award/${awardId}`, awardData);

    if (res.data && res.data.status) {
      toast.success("Award updated successfully!");
      return res.data.data;
    } else {
      toast.error(res.data.message || "Could not update award.");
      return null;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to update award.");
    console.error("API Error updating award:", error);
    return null;
  }
};

export const deleteAwardAPI = async (awardId) => {
  try {
    const res = await apiClient.delete(`admin/delete-award/${awardId}`);

    if (res.data && res.data.status) {
      toast.success("Award deleted successfully!");
      return true;
    } else {
      toast.error(res.data.message || "Could not delete award.");
      return false;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to delete award.");
    console.error("API Error deleting award:", error);
    return false;
  }
};

export const uploadAwardImageAPI = async (formData) => {
  try {
    const res = await apiClient.post("admin/upload-award-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res.data && res.data.status) {
      toast.success(res.data.message || "Image uploaded successfully!");
      return res.data;
    } else {
      toast.error(res.data.message || "Could not upload image.");
      return null;
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Image upload failed.");
    console.error("API Error uploading image:", error);
    return null;
  }
};

export const get_all_payments = async (
  dispatch,
  page,
  limit,
  search,
  startdate,
  enddate
) => {
  try {
    let urlPath = `${REACT_APP_BASE_URL}admin/transaction-history?page=${page}&limit=${limit}&is_export=${true}`;

    if (search) {
      urlPath += `&search=${encodeURIComponent(search)}`;
    }

    if (startdate) {
      urlPath += `&start_date=${startdate}`;
    }

    if (enddate) {
      urlPath += `&end_date=${enddate}`;
    }

    const res = await apiClient.get(urlPath);

    if (res.data) {
      return res;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const export_all_payments = async (
  dispatch,
  search,
  startdate,
  enddate
) => {
  try {
    let query = [];

    if (search) {
      query.push(`search=${encodeURIComponent(search)}`);
    }

    if (startdate) {
      query.push(`start_date=${startdate}`);
    }

    if (enddate) {
      query.push(`end_date=${enddate}`);
    }

    const urlPath = `${REACT_APP_BASE_URL}admin/transaction-history?is_export={false}${
      query.length ? `&${query.join("&")}` : ""
    }`;

    const res = await apiClient.get(urlPath);

    if (res.data) {
      return res;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};
export const get_analytics_data = async (token, dispatch, start, end) => {
  try {
    let urlPath = `${REACT_APP_BASE_URL}admin/get-total-count`;
    if (start && end) {
      urlPath += `?start_date=${start}&end_date=${end}`;
    }
    const HEADERS = {
      headers: { "x-access-token": token },
    };
    const res = await axios.get(urlPath, HEADERS);
    if (res.data && res.data.status) {
      dispatch({ type: GET_ANALYTICS_DATA, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const get_logs_data = async (
  token,
  dispatch,
  page,
  limit,
  filterval
) => {
  try {
    const urlPath = `${REACT_APP_BASE_URL}admin/user-logs?page=${page}&limit=${limit}&action_type=${filterval}`;
    const HEADERS = {
      headers: { "x-access-token": token },
    };
    const res = await axios.get(urlPath, HEADERS);
    if (res.data && res.data.status) {
      dispatch({ type: GET_LOGS_DATA, payload: res.data });
      return res;
    } else {
      return null;
    }
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

export const get_attributes = async (token, page = 1, perPage = 10) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/get-attributes?page=${page}&limit=${perPage}`;
    const res = await axios.get(urlPath, headers);
    if (res?.data) {
      return res;
    }
  } catch (error) {}
};

export const add_variant = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}items/add-variants`;

    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      toast.success(res?.data?.message || "Added");
    }
  } catch (error) {
    toast.error(error?.response?.message || "Failed");
  }
};

export const add_size = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/add-sizes`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      toast.success(res?.data?.message || "Added");
    }
  } catch (error) {
    toast.error(error?.response?.message || "Failed");
  }
};

// BRAND APIS START

export const add_brand_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/add-brand`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Brand name is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(error?.response?.message || error?.response?.data?.error);
    return false;
  }
};

export const get_brand_name = async (
  token,
  search,
  page = 1,
  limit = 10,
  filter = true,
  status = "ACTIVE"
) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    let urlPath = `${REACT_APP_BASE_URL}item/get-brands?page=${page}&limit=${limit}&is_community_brand=${filter}`;
    if (status) {
      urlPath += `&status=${status}`;
    }

    if (search) urlPath += `&search=${search}`;

    const res = await axios.get(urlPath, headers);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

export const get_brand_name_without_pagination = async (status = "ACTIVE") => {
  try {
    let urlPath = `${REACT_APP_BASE_URL}item/get-brands?status=${status}`;

    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

export const delete_brand_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-all-brand/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

export const update_brand_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/update-brand/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// BRAND APIS END

// ACTIVITY APIS START

export const add_activity_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-activity`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Brand name is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(error?.response?.message || error?.response?.data?.error);
    return false;
  }
};

export const get_activity_name = async (
  token,
  search,
  page = 1,
  limit = 10
) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    let urlPath = `${REACT_APP_BASE_URL}admin/get-activity?page=${page}&limit=${limit}`;

    if (search) urlPath += `&search=${search}`;

    const res = await axios.get(urlPath, headers);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

export const delete_activity_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/delete-activity/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

export const update_activity_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/update-activity/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// ACTIVITY APIS END

//ATTRIBUTES APIS START

export const add_attribute = async (token, data) => {
  try {
    const headers = {
      headers: { "x-access-token": token },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/add-attributes`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message);
      return true;
    }
  } catch (error) {
    toast.error(
      error?.response?.message || error?.response?.data?.error || "Failed"
    );
  }
};

export const delete_attribute = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-attribute/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.error || error?.response?.message || "Failed"
    );
  }
};

export const edit_atribute = async (token, data, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/edit-attribute/${id}`;

    const res = await axios.put(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.error || error?.response?.message || "Failed"
    );
  }
};

export const add_values_attributes = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/add-attribute-value`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Values added Successfully");
      return true;
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.error ||
        error?.response?.message ||
        "Failed to add Values"
    );
  }
};

export const get_attributes_values = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    let urlPath = `${REACT_APP_BASE_URL}item/get-attributes-value`;
    if (id) {
      urlPath += `?attribute_id=${id}`;
    }

    const res = await axios.get(urlPath, headers);

    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const delete_attribute_values = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-attribute-value/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.error || error?.response?.message || "Failed"
    );
  }
};

export const generate_variants = async (token, ids) => {
  try {
    const urlPath = `${REACT_APP_BASE_URL}item/add-variants`;
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const res = await axios.post(urlPath, ids, headers);
    if (res?.data) {
      show_success(res?.data?.message);
      return true;
    }
  } catch (error) {
    toast.error(
      error?.response?.message ||
        error?.response?.data?.error ||
        "Failed to generate Variants"
    );
  }
};

// ATTRIBUTES APIS END

// VARIANTS START

export const get_variants = async (token, id, status) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };
    console.log("hedaers token", token);
    let urlPath = `${REACT_APP_BASE_URL}item/get-variants`;

    const queryParams = new URLSearchParams();

    if (id) queryParams.append("product_id", id);
    if (status) queryParams.append("status", status);

    if (queryParams.toString()) {
      urlPath += `?${queryParams.toString()}`;
    }
    const res = await axios.get(urlPath, headers);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const delete_variant = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-variant/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.error || error?.response?.message || "Failed"
    );
  }
};

export const edit_variants = async (token, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/edit-variant`;
    if (!payload.variantId) return;
    const requestBody = {
      variantId: payload.variantId,
      attribute_value_ids: payload.attribute_value_ids,
      images: payload.images,
    };

    const res = await axios.put(urlPath, requestBody, headers);

    if (res?.data) {
      // show_success(res?.data?.message || "Variant updated successfully!");
      return res.data;
    }
    return res;
  } catch (error) {
    console.error("Error in edit_variants:", error);
    toast.error(
      error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.response?.message ||
        "Failed to update variant"
    );
    throw error;
  }
};

export const approve_variants = async (
  selectedProduct,
  finalStatus,
  reason
) => {
  try {
    console.log("payload", selectedProduct, finalStatus, reason);
    const payload = {
      variant_id: selectedProduct,
      action: finalStatus,
    };
    if (reason) {
      payload.reason = reason;
    }
    const urlPath = `item/approve-variants`;
    const res = await apiClient.post(urlPath, payload);
    if (res?.data?.message) {
      show_success(res?.data?.message || "Approved Successfully");
      return true;
    }
  } catch (error) {}
};

export const delete_variantby_productId = async (id) => {
  try {
    const data = {
      product_id: id,
    };
    console.log("data ", data);
    const urlPath = `admin/delete-variant-by-productid`;
    const res = await apiClient.delete(urlPath, { data });
  } catch (error) {}
};

export const edit_variantby_productId = async (payload) => {
  try {
    const urlPath = `/admin/edit-variants-by-productid`;
    console.log("payload", payload);
    const res = await apiClient.put(urlPath, payload);
    if (res?.data) {
      show_success(res?.data?.message || "Edited Successfully");
      return true;
    }
  } catch (error) {}
};

export const approve_variants_by_productid = async (body) => {
  try {
    const urlPath = `admin/approve-variants-by-productid`;
    const res = await apiClient.post(urlPath, body);
    if (res?.data) {
      show_success(res?.data?.message || "Status Updated Successfully ");
      return true;
    }
  } catch (error) {}
};

// VARIANTS END

//AUCTIONS START

export const auction_list_details = async (auctionId) => {
  try {
    const urlpath = `admin/get-auction-detail-admin?auction_id=${auctionId}`;
    const res = await apiClient.get(urlpath);
    if (res?.data?.data) {
      return res?.data?.data;
    }
  } catch (error) {}
};

export const change_auction_status = async (auctionId, status, reason) => {
  try {
    const urlpath = `admin/approve-auction`;
    const statusFinal = status == "approved" ? "approve" : status;
    const payload = {
      auction_id: auctionId,
      action: statusFinal,
    };
    if (status == "reject") {
      payload.reason = reason;
    }
    let res = await apiClient.post(urlpath, payload);

    if (res?.data) {
      show_success(res?.data?.message || "Status changed successfully");
      return res?.data;
    }
  } catch (error) {
    console.error("Error changing auction status:", error);
    toast.error(error?.response?.data?.error || "Failed to change status");
  }
};

export const approve_maser_product = async (id, action, reason) => {
  const payload = {
    product_id: id,
    action: action,
  };

  if (reason) {
    payload.reason = reason;
  }

  try {
    const urlPath = `item/approve-product`;
    const res = await apiClient.post(urlPath, payload);
    if (res?.data) {
      show_success(res?.data?.message);
      return true;
    }
  } catch (error) {}
};

// MASTER PRODUCT APPROVAL END

// TYPE START

export const add_type = async (payload) => {
  try {
    const urlPath = `admin/add-product-type`;
    const res = await apiClient.post(urlPath, payload);

    if (res?.data) {
      show_success(res?.data?.message || "Type Added Successfully");
      return res.data;
    }
  } catch (error) {}
};

//'https://apistox.visionvivante.in/admin/add-subtype' \

export const add_sub_type = async (payload) => {
  try {
    const urlPath = `admin/add-subtype`;
    const res = await apiClient.post(urlPath, payload);

    if (res?.data) {
      show_success(res?.data?.message || "Sub Type Added Successfully");
      return true;
    }
  } catch (error) {
    console.log("error", error?.response?.data?.message);
    // toast.error(error?.response?.data?.message|| "Failed to add")
  }
};

export const add_sub_type_category = async (payload) => {
  try {
    //admin/add-subtype-category' \

    const urlPath = `admin/add-subtype-category`;
    const res = await apiClient.post(urlPath, payload);

    if (res?.data) {
      show_success(res?.data?.message || "Sub Type Added Successfully");
      return true;
    }
  } catch (error) {}
};

export const create_blog = async (payload) => {
  try {
    const urlPath = `cms/add-blog-post`;
    const res = await apiClient.post(urlPath, payload);
    if (res?.data) {
      show_success(res?.data?.message || "Blog created sucessfully");
      return true;
    }
  } catch (error) {}
};

export const get_create_blog = async () => {
  try {
    const urlPath = `cms/get-blog-post`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const get_types = async () => {
  try {
    const urlPath = `item/get-product-types`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const get_sub_types = async (id) => {
  try {
    const urlPath = `item/get-product-subtypes?product_category_id=${id}`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

//curl --location 'https://apistox.visionvivante.in/item/get-subtypes-category?subtype_id=22'

export const get_sub_type_category = async (id) => {
  try {
    const urlPath = `item/get-subtypes-category?subtype_id=${id}`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const edit_type = async (payload) => {
  try {
    const urlPath = `admin/edit-product-type`;
    const res = await apiClient.put(urlPath, payload);
    if (res?.data) {
      show_success(res?.data?.message || "Edited Successfully");
      return true;
    }
  } catch (error) {}
  get_sub_type_category;
};

export const edit_blog_post = async (payload) => {
  try {
    const urlPath = `cms/edit-blog-post`;
    const res = await apiClient.put(urlPath, payload);
    if (res?.data) {
      show_success(res?.data?.message || "Edited Successfully");
      return true;
    }
  } catch (error) {}
};

export const replace_blog_post = async (payload) => {
  try {
    const urlPath = `cms/replace-blog-post`;
    const res = await apiClient.put(urlPath, payload);
    if (res?.data) {
      show_success(res?.data?.message || "Edited Successfully");
      return true;
    }
  } catch (error) {}
};

//admin/update-subtype/19' \

export const edit_sub_type = async (id, payload) => {
  console.log("End");
  try {
    const urlPath = `admin/update-subtype/${id}`;
    const res = await apiClient.put(urlPath, payload);

    if (res?.data) {
      show_success(res?.data?.message || "Edited Successfully");
      return true;
    }
  } catch (error) {}
};
//https://apistox.visionvivante.in/admin/update-subtype-category?subtype_category_id=1' \

export const edit_sub_type_category = async (id, payload) => {
  console.log("End");
  try {
    const urlPath = `admin/update-subtype-category?subtype_category_id=${id}`;
    const res = await apiClient.put(urlPath, payload);

    if (res?.data) {
      show_success(res?.data?.message || "Edited Successfully");
      return true;
    }
  } catch (error) {}
};

export const delete_type = async (id) => {
  try {
    const urlPath = `item/delete-product-type/${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data) {
      show_success(res?.data?.message || "Type deleted Successfully");
      return true;
    }
  } catch (error) {}
};

export const blog_delete_type = async (id) => {
  try {
    const urlPath = `cms/delete-blog-post?blog_id=${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data) {
      show_success(res?.data?.message || "Blog deleted Successfully");
      return true;
    }
  } catch (error) {}
};

export const delete_sub_type = async (id) => {
  try {
    const urlPath = `item/delete-product-subtypes/${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data) {
      show_success(res?.data?.message || "Type deleted Successfully");
      return true;
    }
  } catch (error) {}
};
//admin/delete-subtype-category?subtype_category_id=1' \
export const delete_sub_type_category = async (id) => {
  try {
    const urlPath = `admin/delete-subtype-category?subtype_category_id=${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data) {
      show_success(res?.data?.message || "Type deleted Successfully");
      return true;
    }
  } catch (error) {}
};

// TYPE END

// SIZE ALONG WITH PRICE START

export const size_with_price = async (id, brand, gender, category) => {
  // console.log("hiit id1 and id2 " , id )
  try {
    let urlPath = `admin/get-sizes-by-type?type_id=${id}`;
    if (brand != null) {
      urlPath += `&brand_id=${brand}`;
    }
    if (gender != null) {
      urlPath += `&gender_id=${gender}`;
    }
    if (category != null) {
      urlPath += `&category_id=${category}`;
    }
    const res = await apiClient.get(urlPath);

    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

// SIZE ALONG WITH PRICE END

// Get kides sizes api hit//
export const getKidSizes = async (id) => {
  try {
    const urlPath = `admin/get-kid-sizes?type_id=${id}`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};
// master product start

export const master_product = async (values) => {
  try {
    const urlPath = `admin/master-products`;
    const res = await apiClient.post(urlPath, values);
    if (res?.data) {
      show_success(res?.data?.message || "Product Added Successfully");
      return true;
    }
  } catch (error) {}
};

//'https://apistox.visionvivante.in/item/get-master-product?search=Halloween&brand_name=&product_category_id=7&gender_id=%27 \

export const get_master_product_latest = async (
  search,
  token,
  filter,
  page = 1,
  limit = 10,
  sortPrice,
  order
) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    let urlPath = `item/get-master-product?search=${search}&product_category_id=${filter}&page=${page}&limit=${limit}`;
    if (sortPrice) {
      urlPath += `&sort_by=${sortPrice}&sort_order=${order}`;
    }
    const res = await apiClient.get(urlPath, headers);
    if (res.data) {
      return res;
    }
  } catch (error) {
    toast.error(error?.response?.data);
  }
};

// [17:57] manshiv saini
// curl --location 'https://apistox.visionvivante.in/item/get-models'

export const get_models = async (token, search) => {
  try {
    let urlPath = `item/get-models`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

// [17:57] manshiv saini
// curl --location 'https://apistox.visionvivante.in/item/get-materials'
export const get_materials = async (token, search) => {
  try {
    let urlPath = `item/get-materials`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

// [17:57] manshiv saini
// curl --location 'https://apistox.visionvivante.in/item/get-product-subtypes'
export const get_subtypes = async (token, search, category) => {
  try {
    let urlPath = `item/get-product-subtypes`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

// [17:57] manshiv saini
// curl --location 'https://apistox.visionvivante.in/item/get-seasons'

export const get_seasons = async (token, search) => {
  try {
    let urlPath = `item/get-seasons`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};
// [17:57] manshiv saini
// curl --location 'https://apistox.visionvivante.in/item/get-genders'
export const get_genders = async (token, search) => {
  try {
    let urlPath = `item/get-genders`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

// [17:57] manshiv saini
// curl --location 'https://apistox.visionvivante.in/item/get-countries-of-origin'

export const get_countries = async (token, search) => {
  try {
    let urlPath = `item/get-countries-of-origin`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

//master product end

// model start
// https://apistox.visionvivante.in/admin/add-model' \
export const add_model_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-model`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Model is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Error"
    );
  }
};

// /'https://apistox.visionvivante.in/admin/edit-model/31'

export const update_model_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/edit-model/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//'https://apistox.visionvivante.in/admin/delete-model/31'

export const delete_model_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-model/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// model end

//materials start

export const add_material_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-material`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Brand name is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Error"
    );
  }
};

// /'https://apistox.visionvivante.in/admin/edit-model/31'

export const update_material_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/edit-material/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//'https://apistox.visionvivante.in/admin/delete-model/31'

export const delete_material_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-material/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// materials end

//seasons start

export const add_season_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-seasons`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Season is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Error"
    );
  }
};

// /'https://apistox.visionvivante.in/admin/edit-model/31'

export const update_season_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/update-seasons/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//'https://apistox.visionvivante.in/admin/delete-model/31'

export const delete_season_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-seasons/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// seasons end

//gender start

export const add_gender_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-genders`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Gender is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// /'https://apistox.visionvivante.in/admin/edit-model/31'

export const update_gender_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/update-genders/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//'https://apistox.visionvivante.in/admin/delete-model/31'

export const delete_gender_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/delete-gender/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//gender end

//country start

export const add_country_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-countries-of-origin`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Country name is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Error"
    );
  }
};

// /'https://apistox.visionvivante.in/admin/edit-model/31'

export const update_country_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/update-countries-of-origin/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//'https://apistox.visionvivante.in/admin/delete-model/31'

export const delete_country_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/delete-countries-of-origin/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// country end

// sub types start

export const add_subtype_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-subtype`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Sub-type is added successfully");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// /'https://apistox.visionvivante.in/admin/edit-model/31'

export const update_subtype_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/update-subtype/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//'https://apistox.visionvivante.in/admin/delete-model/31'

export const delete_subtype_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/delete-subtype/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// sub types end

//'https://apistox.visionvivante.in/admin/update-size-gender' \

export const update_size_gender = async (data) => {
  try {
    const urlPath = `admin/update-size-gender`;
    const res = await apiClient.put(urlPath, data);
    if (res?.data) {
      show_success(res?.data?.message || "Sizes Added Successfully");
    }
  } catch (error) {}
};

//suggestion start

// item/get-suggested-master-products

export const suggested_request = async (status) => {
  try {
    const urlPath = `item/get-suggested-master-products?status=${status}`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      // show_success(res?.data?.message );
      return res;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    // toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//https://apistox.visionvivante.in/item/get-suggest-products-details?suggested_product_id=6

export const suggested_request_detail = async (token, id, dispatch) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/get-suggest-products-details?suggested_product_id=${id}`;
    const res = await axios.get(urlPath);
    if (res?.data) {
      dispatch({ type: GET_PRODUCT_DETAIL, payload: res.data.data });
      return res?.data?.data;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//https://apistox.visionvivante.in/admin/approve-suggested-master-product%27

// export const approve_suggestes_master_products= async (values) => {
//   try {
//     const urlPath = `admin/approve-suggested-master-product`;
//     const res = await apiClient.post(urlPath, values);
//     if (res?.data) {
//       show_success(res?.data?.message || "Product Added Successfully");
//       return true;
//     }
//   } catch (error) {}
// };

export const approve_suggestes_master_products = async (
  id,
  action,
  reason,
  email
) => {
  const payload = {
    suggested_product_id: id,
    action: action,
    email: email,
  };

  if (reason) {
    payload.reason = reason;
  }

  try {
    const urlPath = `admin/approve-suggested-master-product`;
    const res = await apiClient.post(urlPath, payload);
    if (res?.data) {
      show_success(res?.data?.message);
      return true;
    }
  } catch (error) {}
};

//'https://apistox.visionvivante.in/item/edit-suggested-master-products
export const edit_suggested_master_product = async (values) => {
  try {
    const urlPath = `item/edit-suggested-master-products`;
    const res = await apiClient.put(urlPath, values);
    if (res?.data) {
      show_success(
        res?.data?.message || "Suggested Product Updated Successfully"
      );
      return true;
    }
  } catch (error) {}
};

//suggestion end

//color start

export const add_color_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/add-colors`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Color is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Error"
    );
  }
};

// /'https://apistox.visionvivante.in/admin/edit-model/31'

export const update_color_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}item/update-color/${id}`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

//'https://apistox.visionvivante.in/admin/delete-model/31'

export const delete_color_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/delete-colors/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

export const get_colors = async (token, search) => {
  try {
    let urlPath = `item/get-colors`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

// color end

//SIZE CHART START

export const add_sizes = async (body) => {
  try {
    const urlPath = `admin/add-sizes`;
    const res = await apiClient.post(urlPath, body);
    if (res?.data) {
      show_success(res?.data?.message || "Added Successfully");
      return res?.data;
    }
  } catch (error) {}
};

export const edit_sizes = async (body) => {
  try {
    const urlPath = `admin/update-sizes`;
    const res = await apiClient.put(urlPath, body);
    if (res?.data) {
      //  show_success(res?.data?.message || "Updated Successfully");
      return res?.data;
    }
  } catch (error) {
    return false;
  }
};

export const edit_sizes_features = async (body) => {
  try {
    const urlPath = `admin/update-size-list`;
    const res = await apiClient.put(urlPath, body);
    if (res?.data) {
      //  show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    return false;
  }
};

export const delete_size = async (id) => {
  try {
    //admin/delete-by-sizes
    // const urlPath = `admin/delete-size?size_id=${id}`;
    const urlPath = `admin/delete-by-sizes/${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {}
};

export const size_chart = async () => {
  try {
    const urlPath = `admin/get-sizes-list`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const delete_size_row = async (data) => {
  try {
    console.log("data", data);
    const urlPath = `admin/delete-sizes-list`;
    const res = await apiClient.delete(urlPath, { data: data });
    console.log("res", res);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {}
};
//SIZE CHART END

// STYLE ID SUGGESTIONS API  START

export const style_id_suggestions = async (search) => {
  try {
    const urlPath = `item/searchSku?search=${search}`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res;
    }
  } catch (error) {}
};

// STYLE ID SUGGESTIONS API END

//REGION API START

export const delete_size_region = async (id) => {
  try {
    const urlPath = `admin/delete-conversion/${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data) {
      show_success(res?.data?.message || "Type deleted Successfully");
      return true;
    }
  } catch (error) {}
};

export const add_region_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-conversion`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Region is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Error"
    );
  }
};

export const get_regions = async (token, search) => {
  try {
    let urlPath = `admin/get-conversion`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const update_region_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/update-conversion`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

export const delete_region_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/delete-colors/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};
// REGION API END

// SIZE CATEGORY START

export const add_category_name = async (token, data) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/add-size-category`;
    const res = await axios.post(urlPath, data, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Category is added");
      return true;
    }
  } catch (error) {
    console.log("resposne error ", error?.response?.data?.error);
    toast.error(
      error?.response?.message || error?.response?.data?.message || "Error"
    );
  }
};

export const get_size_category = async (token, search) => {
  try {
    let urlPath = `admin/get-size-category`;
    if (search) {
      urlPath += `?search=${search}`;
    }
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const update_category_name = async (token, id, payload) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };
    const urlPath = `${REACT_APP_BASE_URL}admin/edit-size-category`;
    const res = await axios.put(urlPath, payload, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Updated Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};
export const delete_size_category = async (id) => {
  try {
    const urlPath = `admin/delete-size-category/${id}`;
    const res = await apiClient.delete(urlPath);
    if (res?.data) {
      show_success(res?.data?.message || "Type deleted Successfully");
      return true;
    }
  } catch (error) {}
};
export const delete_category_name = async (token, id) => {
  try {
    const headers = {
      headers: {
        "x-access-token": token,
      },
    };

    const urlPath = `${REACT_APP_BASE_URL}item/delete-colors/${id}`;
    const res = await axios.delete(urlPath, headers);
    if (res?.data) {
      show_success(res?.data?.message || "Deleted Successfully");
      return true;
    }
  } catch (error) {
    toast.error(error?.response?.message || error?.response?.data?.error);
  }
};

// SIZE CATEGORY END

// ORDERS API START
//
export const get_all_orders = async (page = 1, limit = 10, status) => {
  try {
    // const urlPath = `${REACT_APP_BASE_URL}admin/order-list?status=${status}&page=${page}&limit=${limit}`;
    let urlPath = `admin/get-orders-details?page=${page}&limit=${limit}`;
    if (status) {
      urlPath += `&shipping_status=${status}`;
    }
    const res = await apiClient.get(urlPath);

    if (res.data) {
      // dispatch({ type: GET_ORDER_LISTS, payload: res.data });
      return res?.data;
    } else {
      return null;
    }
  } catch (error) {
    // check_token_expired_logout(error, dispatch);
  }
};

export const view_order_details = async (id) => {
  try {
    const urlPath = `admin/get-orders-view-details/${id}`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

//admin/get-buyer-list
export const get_sellers = async ({
  value,
  page,
  rows,
  email,
  startDate,
  endDate,
  sortBy,
  admin_verified
}) => {
  try {
    let urlpath = `admin/get-seller-list?limit=${rows}&page=${page}`;
    if (value != null) {
      urlpath += `&admin_verified=${value}`;
    }
    if (email) {
      urlpath += `&search=${email}`;
    }
    if (startDate) {
      urlpath += `&start_date=${startDate}`;
    }
    if (endDate) {
      urlpath += `&end_date=${endDate}`;
    }
    if (sortBy) {
      urlpath += `&sort_by=${sortBy}&order_by=desc`;
    }
    const res = await apiClient.get(urlpath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const get_buyers = async ({
  page,
  rows,
  email,
  filter,
  startDate,
  endDate,
  sortBy,
}) => {
  try {
    let urlpath = `admin/get-buyer-list?page=${page}&limit=${rows}`;
    if (filter != null) {
      urlpath += `&email_verify=${filter}`;
    }
    if (email) {
      urlpath += `&search=${email}`;
    }
    if (startDate) {
      urlpath += `&start_date=${startDate}`;
    }
    if (endDate) {
      urlpath += `&end_date=${endDate}`;
    }
    if (sortBy) {
      urlpath += `&sort_by=${sortBy}&order_by=desc`;
    }
    const res = await apiClient.get(urlpath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const get_seller_by_id = async (id) => {
  try {
    const urlPath = `admin/seller-details/${id}`;
    const res = await apiClient.get(urlPath);
    if (res?.data) {
      return res?.data;
    }
  } catch (error) {}
};

export const verify_seller = async (id) => {
  try {
    const urlPath = `admin/update-seller-list/${id}`;
    const res = await apiClient.put(urlPath);
    show_success(res?.data?.message || "Verified Successfully");
    return true;
  } catch (error) {}
};

export const delete_buyer = async (id) => {
  try {
    const urlPath = `admin/buyer-delete/${id}`;
    const res = await apiClient.delete(urlPath);
    show_success(res?.data?.message || "Buyer deleted Successfully");
    return true;
  } catch (error) {}
};

export const delete_seller = async (id) => {
  try {
    const urlPath = `admin/buyer-delete/${id}`;
    const res = await apiClient.delete(urlPath);
    show_success(res?.data?.message || "Buyer deleted Successfully");
    return true;
  } catch (error) {}
};

// ORDERS API END

//slider apis start

export const slider_add_image = async (data) => {
  console.log("slider_add_image function called", data); // Add this
  try {
    console.log("test"); // This should show if function executes
    const urlPath = `admin/add-home-slider`;
    const slider = await apiClient.post(urlPath, data);
    show_success(slider?.data?.message || "Image Added Successfully");
    return true;
  } catch (error) {
    console.log("Error in slider_add_image:", error); // Add error logging
  }
};

export const sliders_images = async () => {
  try {
    const urlPath = `admin/get-home-slider`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const delete_slider_image = async (id) => {
  try {
    const urlPath = `admin/delete-home-slider/${id}`;
    const res = await apiClient.delete(urlPath);
    return true;
  } catch (error) {}
};

export const edit_slider = async (id, data) => {
  try {
    const urlPath = `admin/edit-home-slider/${id}`;
    const res = await apiClient.put(urlPath, data);
    return true;
  } catch (error) {}
};

// slider apis end

//seller bulk ask apis start

export const get_seller_askable_products = async (payload) => {
  try {
    const urlPath = `item/seller-askable-products`;
    const res = await apiClient.post(urlPath, payload);
    return res;
  } catch (error) {
    console.error("get_seller_askable_products failed:", error?.response?.data || error?.message);
  }
};

export const bulk_upload_seller_asks = async (formData) => {
  try {
    const urlPath = `auction/bulk-upload-asks`;
    const res = await apiClient.post(urlPath, formData);
    show_success(res?.data?.message || "Asks uploaded successfully");
    return res ;
  }
  catch{
  }
  }
//popup apis start

export const get_active_popup = async () => {
  try {
    const urlPath = `popup/active`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const get_popups_admin = async (
  page,
  limit,
  search,
  is_active,
  include_deleted
) => {
  try {
    let urlPath = `popup/admin?page=${page}&limit=${limit}`;
    if (search) urlPath += `&search=${search}`;
    if (is_active !== "" && is_active !== undefined && is_active !== null) {
      urlPath += `&is_active=${is_active}`;
    }
    if (include_deleted) urlPath += `&include_deleted=${include_deleted}`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const get_ask_upload_jobs = async (page, limit) => {
  try {
    const urlPath = `auction/ask-upload-jobs?page=${page}&limit=${limit}`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};
    
    
 export const get_popup_admin = async (id) => {
  try {
    const urlPath = `popup/admin/${id}`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const get_ask_upload_job_detail = async (jobId) => {
  try {
    const urlPath = `auction/ask-upload-jobs/${jobId}`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

// seller bulk ask apis end
export const add_popup = async (data) => {
  try {
    const urlPath = `popup/admin`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message || "Popup version added successfully");
    return true;
  } catch (error) {}
};

export const edit_popup = async (id, data) => {
  try {
    const urlPath = `popup/admin/${id}`;
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Popup version updated successfully");
    return true;
  } catch (error) {}
};

export const activate_popup = async (id) => {
  try {
    const urlPath = `popup/admin/${id}/activate`;
    const res = await apiClient.patch(urlPath);
    show_success(res?.data?.message || "Popup activated successfully");
    return true;
  } catch (error) {}
};

export const delete_popup = async (id) => {
  try {
    const urlPath = `popup/admin/${id}`;
    const res = await apiClient.delete(urlPath);
    show_success(res?.data?.message || "Deleted Successfully");
    return true;
  } catch (error) {}
};

// popup apis end

//change password

export const change_password = async (data, token) => {
  try {
    const urlPath = `auth/change-password`;
    const HEADERS = {
      headers: {
        token: token,
      },
    };
    const res = await apiClient.post(urlPath, data, HEADERS);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

// store products

export const store_products_list = async (
  search,
  limit,
  page,
  sortby,
  sortorder
) => {
  try {
    let urlPath = `admin/get-product-listing?limit=${limit}&page=${page}`;
    if (search) {
      urlPath += `&search=${search}`;
    }
    if (sortby || sortorder) {
      urlPath += `&sort_by=${sortby}&sort_order=${sortorder}`;
    }
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const restore_product = async (id) => {
  try {
    let urlPath = `admin/edit-product-listing/${id}`;
    const data = {
      is_deleted: false,
    };
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Product restored successfully");
    return true;
  } catch (error) {}
};

//restore sizes

export const restore_sizes = async () => {
  try {
    const urlPath = `admin/get-deleted-sizes`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const edit_deleted_size = async (data) => {
  try {
    const urlPath = `admin/edit-size`;
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Restored Succesfully");
    return true;
  } catch (error) {}
};

export const delete_size_row_permanent = async (payload) => {
  try {
    const urlPath = `admin/delete-sizee-list`;
    const res = await apiClient.delete(urlPath, { data: payload });
    show_success(res?.data?.message || "Deleted Successfully");
    return true;
  } catch (error) {}
};

export const add_transaction_fee = async (payload, id) => {
  try {
    const urlPath = `admin/add-seller-fee/${id}`;
    const res = await apiClient.post(urlPath, payload);
    show_success(res?.data?.message || "Fee added successfully");
  } catch (error) {}
};

export const order_decision = async (id, data) => {
  try {
    const urlPath = `admin/update-order-verification-status/${id}`;
    const res = await apiClient.patch(urlPath, data);
    show_success(res?.data?.message || "Done");
  } catch (error) {}
};
export const send_order_shippment = async (data) => {
  try {
    const urlPath = `shipping/send-order-shippment`;
    const res = await apiClient.post(urlPath, data);
    return true;
  } catch (error) {}
};

export const delete_master_product_permanently = async (id) => {
  try {
    const urlPath = `admin/delete-product-listing/${id}`;
    const res = await apiClient.delete(urlPath);
    show_success(res?.data?.message || "Deleted Successfully");
    return true;
  } catch (error) {}
};

export const bidders_ask_list = async (
  type,
  page,
  limit,
  debouncedValue,
  sort_by,
  sort_order
) => {
  try {
    let urlPath = `admin/get-auction-overview?type=${type}&page=${page}&limit=${limit}`;
    if (sort_by) {
      urlPath += `&sort_by=${sort_by}`;
    }
    if (sort_order) {
      urlPath += `&sort_order=${sort_order}`;
    }
    if (debouncedValue) {
      urlPath += `&search=${debouncedValue}`;
    }
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const print_order_detail = async (token_id, val) => {
  try {
    let urlPath = `shipping/shipment-label/${token_id}`;
    if (val) {
      urlPath += `?is_both_page_download=true`;
    }

    const res = await apiClient.get(urlPath, {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    });

    return res;
  } catch (error) {
    console.error(error);
  }
};

export const transaction_report = async (data) => {
  try {
    let urlPath = `admin/transaction-report`;

    const params = Object.fromEntries(
      Object.entries({
        buyerEmail: data?.buyerEmail,
        sellerEmail: data?.sellerEmail,
        fromDate: data?.fromDate,
        toDate: data?.toDate,
        subtitle: data?.subtitle,
        productName: data?.productName,
        brand: data?.brand,
        category: data?.category,
        style_id: data?.style_id,
      }).filter(([_, value]) => value)
    );

    const res = await apiClient.get(urlPath, { params });

    return res;
  } catch (error) {
    console.error(error);
  }
};

export const bank_detail = async (id) => {
  try {
    const urlPath = `admin/seller-bank-details/${id}`;
    console.log("rtest 2");
    const res = await apiClient.get(urlPath);
    return res?.data?.data;
  } catch (error) {}
};

export const admin_skip_shipment = async (id) => {
  try {
    const urlPath = `admin/skip-seller-shipment/${id}`;
    const res = await apiClient.post(urlPath);
    if (res) return true;
  } catch (error) {}
};

export const get_coupons = async (page, limit, search, filter) => {
  try {
    const type = filter.toLowerCase();
    let urlPath = `admin/coupon?page=${page}&limit=${limit}&type=${type}`;
    if (search) {
      urlPath += `&search=${search}`;
    }
    const res = apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const add_coupons = async (data) => {
  try {
    const urlPath = `admin/coupon`;
    const res = apiClient.post(urlPath, data);
    return res;
  } catch (error) {
    return false;
  }
};

export const delete_coupon = async (id) => {
  try {
    const urlPath = `admin/coupon/${id}`;
    const res = await apiClient.delete(urlPath);
    return true;
  } catch (error) {}
};

export const get_offers = async (params) => {
  try {
    const res = await apiClient.get("offers/admin", { params });
    return res?.data;
  } catch (error) {}
};

export const add_offer = async (data) => {
  try {
    const res = await apiClient.post("offers/admin", data);
    show_success(res?.data?.message || "Offer added");
    return true;
  } catch (error) {
    return false;
  }
};

export const edit_offer = async (id, data) => {
  try {
    const res = await apiClient.put(`offers/admin/${id}`, data);
    show_success(res?.data?.message || "Offer updated");
    return true;
  } catch (error) {
    return false;
  }
};

export const change_offer_status = async (id, activate) => {
  try {
    const action = activate ? "activate" : "deactivate";
    const res = await apiClient.patch(`offers/admin/${id}/${action}`);
    show_success(res?.data?.message || `Offer ${action}d`);
    return true;
  } catch (error) {
    return false;
  }
};

export const delete_offer = async (id) => {
  try {
    const res = await apiClient.delete(`offers/admin/${id}`);
    show_success(res?.data?.message || "Offer deleted");
    return true;
  } catch (error) {
    return false;
  }
};

export const seller_from_ngo = async (data, id) => {
  try {
    const urlPath = `admin/make-community-seller/${id}`;
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Seller is now a Community Seller");
    return true;
  } catch (error) {}
};

export const add_broken_cards = async (data) => {
  try {
    const urlPath = `/broken-cards/product/admin`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message || "Added");
    return true;
  } catch (error) {}
};

export const get_broken_cards = async ({
  status,
  sortBy,
  search,
  page,
  limit,
  startDate,
  endDate,
}) => {
  try {
    const urlPath = `/broken-cards/product/admin`;
    const params = {};
    if (status) {
      params.status = status;
    }
    if (sortBy) {
      params.sort_by = sortBy;
    }
    if (search) {
      params.search = search;
    }
    if (page) {
      params.page = page;
    }
    if (limit) {
      params.limit = limit;
    }
    if (startDate) {
      params.from_date = startDate;
    }
    if (endDate) {
      params.to_date = endDate;
    }
    const res = await apiClient.get(urlPath, { params: params });
    return res?.data;
  } catch (error) {}
};

export const get_broken_cards_by_id = async (id) => {
  try {
    const urlPath = `/broken-cards/product/admin/${id}`;
    const res = await apiClient.get(urlPath);
    return res?.data;
  } catch (error) {}
};

export const edit_broken_cards = async (id, data) => {
  try {
    const urlPath = `/broken-cards/product/admin/${id}`;
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Updated");
    return res?.data;
  } catch (error) {}
};

export const delete_broken_cards_id = async (id) => {
  try {
    const urlPath = `/broken-cards/product/admin/${id}`;
    const res = await apiClient.delete(urlPath);
    return true;
  } catch (error) {}
};

export const edit_category_broken_card = async (id, data) => {
  try {
    const urlpath = `/product/admin/category/${id}`;
    const res = await apiClient.put(urlpath, data);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const schedule_live_meeting = async (payload, id) => {
  try {
    const urlPath = `/broken-cards/schedule/live/admin/${id}`;
    const res = await apiClient.post(urlPath, payload);
    show_success(res?.data?.message || "Scheduled Successfully");
    return true;
  } catch (error) {}
};

export const broken_card_detail = async (id) => {
  try {
    const urlPath = `/broken-cards/product/admin/${id}`;
    const res = await apiClient.get(urlPath);
    return res?.data;
  } catch (error) {}
};

export const live_card_stream = async (id) => {
  try {
    const urlPath = `/broken-cards/stream/live/admin/${id}`;
    const res = await apiClient.post(urlPath);
    show_success(res?.data?.message || "Live Stream");
    return res?.data;
  } catch (error) {}
};

export const end_live_stream = async (id) => {
  try {
    const urlPath = `/broken-cards/stream/completed/admin/${id}`;
    const res = await apiClient.post(urlPath);
    show_success(res?.data?.message || "Stream Completed");
    return true;
  } catch (error) {}
};

export const add_box_category = async (data) => {
  try {
    const urlPath = `/broken-cards/team/admin`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const get_box_category = async () => {
  try {
    const urlPath = `/broken-cards/team/admin`;
    const res = await apiClient.get(urlPath);
    return res?.data;
  } catch (error) {}
};

export const delete_box_category = async (id) => {
  try {
    const urlPath = `/broken-cards/team/admin/${id}`;
    const res = await apiClient.delete(urlPath);
    show_success(res?.data?.message);
    return res?.data;
  } catch (error) {}
};
export const edit_box_category = async (data, id) => {
  try {
    const urlPath = `/broken-cards/team/admin/${id}`;
    const res = await apiClient.patch(urlPath, data);
    show_success(res?.data?.message || "Updated Successfully");
    return res?.data;
  } catch (error) {}
};

export const add_box_category_team = async (data) => {
  try {
    const urlPath = `/broken-cards/team/category/admin`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const get_box_category_team = async (id) => {
  try {
    const urlPath = `/broken-cards/team/category/admin?bpt_id=${id}`;
    const res = await apiClient.get(urlPath);
    return res?.data;
  } catch (error) {}
};

export const delete_box_category_team = async (id) => {
  try {
    const urlPath = `/broken-cards/team/category/admin/${id}`;
    const res = await apiClient.delete(urlPath);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const edit_box_category_team = async (data, id, bpt_id) => {
  try {
    const urlPath = `/broken-cards/team/category/admin/${id}`;
    const res = await apiClient.patch(urlPath, data);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const decide_win_loss = async (id, data) => {
  try {
    const urlPath = `/broken-cards/winners/admin/${id}`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message || "Updated");
    return true;
  } catch (error) {}
};

export const create_card_shipment = async (payload) => {
  try {
    const urlPath = `/broken-cards/shipment/admin`;
    const res = await apiClient.post(urlPath, payload);
    show_success(res?.data?.message || "Shipment is created");
    return true;
  } catch (error) {}
};

export const republish_card = async (id) => {
  try {
    const urlPath = `/broken-cards/product/recreate/admin/${id}`;
    const res = await apiClient.post(urlPath);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const box_wallet_requests = async (status, search) => {
  try {
    let urlPath = `/broken-cards/box/admin`;
    if (status && status !== "All") urlPath += `?status=${status}`;
    if (search) urlPath += `?search=${search}`;
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const box_measurements = async (id, data) => {
  try {
    let urlPath = `/broken-cards/box/admin/${id}/box-size`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const admin_start_shipment = async (id) => {
  try {
    let urlPath = `/broken-cards/box/admin/${id}/create`;
    const res = await apiClient.post(urlPath);
    show_success(res?.data?.message);
    return true;
  } catch (error) {}
};

export const box_wallet_requests_detail = async (id) => {
  try {
    let urlPath = `/broken-cards/box/admin/${id}`;
    const res = await apiClient.get(urlPath);
    show_success(res?.data?.message);
    return res;
  } catch (error) {}
};

export const box_wallet = async ({
  page,
  limit,
  currentStatus,
  debouncedValue,
}) => {
  try {
    let urlPath = `/broken-cards/grading/vault/admin?page=${page}&limit=${limit}`;
    if (currentStatus) {
      urlPath += `&status=${currentStatus}`;
    }
    if (debouncedValue) {
      urlPath += `&search=${debouncedValue}`;
    }
    const res = await apiClient.get(urlPath);
    return res;
  } catch (error) {}
};

export const skip_buyer_shipment = async (id) => {
  try {
    const urlPath = `/admin/skip-buyer-shipment/${id}`;
    const res = await apiClient.post(urlPath);
    show_success(res?.data?.message || "Success");
    return res;
  } catch (error) {}
};

// | `POST /broken-cards/grading/service/admin` | Admin — create service |(name, description, price/card, images
// | `GET /broken-cards/grading/service/admin` | Admin — list all services |
// | `GET /broken-cards/grading/service/admin/:id` | Admin — get service detail |
// | `PUT /broken-cards/grading/service/admin/:id` | Admin — update service |
// | `PATCH /broken-cards/grading/service/admin/:id/status` | Admin — activate / deactivate service |
// | `DELETE /broken-cards/grading/service/admin/:id` | Admin — delete service |
export const get_grading_Services = async () => {
  try {
    const urlPath = "/broken-cards/grading/service/admin";
    const res = await apiClient.get(urlPath);
    return res?.data;
  } catch (error) {}
};

export const post_grading_Services = async (data) => {
  try {
    const urlPath = "/broken-cards/grading/service/admin";
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message || "Grading service added");
    return res?.data;
  } catch (error) {}
};

export const get_grading_Service_id = async (id) => {
  try {
    const urlPath = `/broken-cards/grading/service/admin/${id}`;
    const res = await apiClient.get(urlPath);
    return res?.data;
  } catch (error) {}
};
export const edit_grading_Service = async (id, data) => {
  try {
    const urlPath = `/broken-cards/grading/service/admin/${id}`;
    const res = await apiClient.put(urlPath, data);
    show_success(res?.data?.message || "Grading service updated");
    return res?.data;
  } catch (error) {}
};
export const edit_grading_service_tatus = async (id, data) => {
  try {
    const urlPath = `/broken-cards/grading/service/admin/${id}/status`;
    const res = await apiClient.patch(urlPath, data);
    show_success(res?.data?.message || "Status updated");
    return res?.data;
  } catch (error) {}
};
export const delete_grading_Services = async (id) => {
  try {
    const urlPath = `/broken-cards/grading/service/admin/${id}`;
    const res = await apiClient.delete(urlPath);
    show_success(res?.data?.message || "Grading service deleted");
    return true;
  } catch (error) {}
};

export const confirm_card_received = async (id) => {
  try {
    const urlPath = `/broken-cards/grading/vault/admin/manual-shipment/${id}/confirm`;
    const res = await apiClient.post(urlPath);
    show_success(res?.data?.message || "Confirmed");
    return true;
  } catch {}
};
export const grading_vault_details = async (id) => {
  try {
    const urlPath = `broken-cards/grading/vault/admin/${id}`;
    const res = await apiClient.get(urlPath);
    return res ; 
  } catch {}
};


export const change_grading_status = async (id, status) => {
  try {
    const urlPath = `broken-cards/grading/requests/admin/${id}/status`;
    const res = await apiClient.patch(urlPath, status);
    if (res?.data) {
      toast.success(res.data.message || "Grading status updated", {
        toastId: "gradingstatusupdated",
        autoClose: 2000,
      });
      return true;
    } else {
      toast.error(res?.data?.message || "Could not update grading status.");
      return false;
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Could not update grading status."
    );
    return false;
  }
};


export const card_received_confirmation = async (id, data) => {
  try {
    const urlPath = `broken-cards/grading/vault/admin/manual-shipment/${id}/confirm`;
    const res = await apiClient.post(urlPath, data);
    if (res?.data) {
      toast.success(res.data.message || "Card received confirmed", {
        toastId: "cardreceivedconfirmed",
        autoClose: 2000,
      });
      return true;
    }
    return false;
  } catch {
    return false;
  }
};

export const card_collected_confirmation = async (id, data) => {
  try {
    const urlPath = `broken-cards/grading/vault/admin/manual-shipment/${id}/confirm`;
    const res = await apiClient.post(urlPath, data);
    if (res?.data) {
      show_success(res.data.message || "Card collected confirmed");
      return true;
    }

  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Could not confirm card collected.",
    );
    return false;
  }
};
export const manual_shipment = async (data) => {
  try {
    const urlPath = `admin/manual-shipment`;
    const res = await apiClient.post(urlPath,data);
    show_success(res?.data?.message || "Success");
    return res ;
  } catch (error) {}
};

export const change_tracking_status = async (id, data) => {
  try {
    const urlPath = `admin/manual-shipment/${id}/status`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message || "Success");
    return res;
  } catch (error) {}
}

export const get_replacement_seller_options = async (orderId) => {
  try {
    const urlPath = `admin/replacement-seller-options/${orderId}`;
    const res = await apiClient.get(urlPath);
    return res?.data;
  } catch (error) {}
};

export const assign_new_seller = async (data) => {
  try {
    const urlPath = `admin/assign-new-seller`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message || "New seller assigned successfully");
    return res?.data;
  } catch (error) {}
};

export const cancel_order_seller_failure = async (data) => {
  try {
    const urlPath = `admin/cancel-order-seller-failure`;
    const res = await apiClient.post(urlPath, data);
    show_success(res?.data?.message || "Order cancelled successfully");
    return res?.data;
  } catch (error) {}
};

export const get_subscribers = async (page, limit, search) => {
  const res = await apiClient.get("popup/admin/subscribers", {
    params: { page, limit, ...(search ? { search } : {}) },
  });
  const body = res?.data;
  const list =
    body?.data?.subscribers ||
    body?.data?.rows ||
    body?.subscribers ||
    (Array.isArray(body?.data) ? body.data : []) ||
    [];
  const count =
    body?.data?.total ??
    body?.data?.count ??
    body?.total ??
    body?.count ??
    list.length;
  return { list: Array.isArray(list) ? list : [], total: Number(count) || 0 };
};

export const get_box_break_order_detail = async (id) => {
  const res = await apiClient.get(`broken-cards/slots/admin/${id}`);
  return res?.data?.data ?? null;
};

export const get_box_break_orders = async (page, limit, search = "") => {
  const res = await apiClient.get("broken-cards/slots/admin", {
    params: {
      page,
      limit,
      ...(search?.trim() ? { search: search.trim() } : {}), // change key to "email" if your backend expects that
    },
  });
  const body = res?.data;
  const list = Array.isArray(body?.data) ? body.data : [];
  const count = body?.pagination?.total_records ?? list.length;
  return { list, total: Number(count) || 0 };
};

export const admin_live_auctions_list = async (params) => {
  try {
    const res = await apiClient.get("live-auctions/admin/list", { params });
    return res;
  } catch (error) {}
};

export const admin_live_auction_detail = async (id) => {
  try {
    const res = await apiClient.get(`live-auctions/admin/${id}`);
    return res;
  } catch (error) {}
};

export const admin_bids_list = async (params) => {
  try {
    const res = await apiClient.get("live-auctions/admin/bids", { params });
    return res;
  } catch (error) {}
};

export const admin_bid_detail = async (bidId) => {
  try {
    const res = await apiClient.get(`live-auctions/admin/bids/${bidId}`);
    return res;
  } catch (error) {}
};

export const admin_audit_logs_list = async (params) => {
  try {
    const res = await apiClient.get("admin/audit-logs", { params });
    return res;
  } catch (error) {}
};
